export default String.raw`
{% assign product = product-presentation.Product -%}
{% assign title = translations.ShareProductOn -%}
{% capture shopBase -%}{% include 'partials/common/absolute-base.html' -%}{% endcapture -%}

{% if product.Image.Link == null -%}
    {% assign productShareImg = product.Image.ExternalUrl -%}
{% else -%}
    {% assign imgId = product.Image.Id | ToString -%}
    {% assign productShareImg = shopBase | Append: "img/" | Append: imgId | Append: "/" | Append: product.Image.Link -%}
{% endif -%}

{% assign amp = '&' -%}
{% assign productName = product.NameNoHtml | Replace: amp, '%26' -%}

{% assign productUrl = shopBase | Append: product.Url -%}

{% if page.CanonicalLink contains 'https' -%}
    {% assign isHttps = true -%}
{% else -%}
    {% assign isHttps = false -%}
{% endif -%}

<div class="dropdowns container-to-delete-js">
    {% if settings.share-fb == 'share-fb-yes' -%}
        <a href="https://www.facebook.com/sharer/sharer.php?u={{productUrl}}" target="_blank" title="Facebook">
            <svg><use href="css/img/fontawesome-icons.svg?v={{lqTS}}#facebook-square"></use></svg> Facebook
        </a>
    {% endif -%}

    {% if settings.share-twt == 'share-twt-yes' -%}
        <a href="https://twitter.com/intent/tweet?text={{productName}}&amp;nbsp;&url={{productUrl}}" target="_blank" title="X">
            <svg><use href="css/img/fontawesome-icons.svg?v={{lqTS}}#x-twitter"></use></svg> X.
        </a>
    {% endif -%}

    {% if settings.share-lin == 'share-lin-yes' -%}
        <a href="https://www.linkedin.com/sharing/share-offsite/?url={{productUrl}}" target="_blank" title="LinkedIn">
            <svg><use href="css/img/fontawesome-icons.svg?v={{lqTS}}#linkedin"></use></svg> LinkedIn
        </a>
    {% endif -%}

    {% if settings.share-wa == 'share-wa-yes' -%}
        <a href="https://api.whatsapp.com/send/?text={{productName}}&nbsp;{{productUrl}}&type=custom_url&app_absent=0" target="_blank" title="WhatsApp">
            <svg><use href="css/img/fontawesome-icons.svg?v={{lqTS}}#whatsapp"></use></svg> WhatsApp
        </a>     
    {% endif -%}

    {% if settings.share-pin == 'share-pin-yes' -%}
        <a href="https://pinterest.com/pin/create/button/?url={{productUrl}}&media={{productShareImg}}&description={{productName | Replace: ' ', '+'}}" target="_blank" title="Pinterest">
            <svg><use href="css/img/fontawesome-icons.svg?v={{lqTS}}#pinterest"></use></svg> Pinterest
        </a>    
    {% endif -%}

    {% if settings.share-gmail == 'share-gmail-yes' -%}
        <a href="https://mail.google.com/mail/?extsrc=mailto&url=mailto%3A%3Fto%3D%26subject%3D{{productName}}%26body%3D{{productName}}&nbsp;{{productUrl}}" target="_blank" title="Gmail">
            <svg><use href="css/img/fontawesome-icons.svg?v={{lqTS}}#google"></use></svg> Gmail
        </a>
    {% endif -%}

    {% if isHttps -%}
        <div class="mobile-share-button-js" data-product-name="{{shareProductName}}" data-link="{{productUrl}}">
            <svg><use href="css/img/fontawesome-icons.svg?v={{lqTS}}#share-alt-{{settings.iconStyle}}"></use></svg> {{ translations.ShareMobileApps }}
        </div>
    {% endif -%}

    {% if settings.share-copy == 'share-copy-yes' and isHttps -%}
        <a class="copy-link-js" href="javascript:void(0);" title="{{ translations.CopyLink }}" data-info="{{translations.AfterCopyLinkMessage}}">
            <svg><use href="css/img/fontawesome-icons.svg?v={{lqTS}}#copy-{{settings.iconStyle}}"></use></svg> {{ translations.CopyLink }}
        </a>
    {% endif -%}

    {% if settings.share-mail == 'share-mail-yes' -%}
        <a href="mailto:?subject={{productName}}&body={{productName}}&nbsp;{{productUrl}}" target="_blank" title="{{ translations.ShareByEmail }}" rel="noopener noreferrer">
            <svg><use href="css/img/fontawesome-icons.svg?v={{lqTS}}#envelope-{{settings.iconStyle}}"></use></svg> {{ translations.ShareByEmail }}
        </a>
    {% endif -%}

    {% if settings.share-rec == 'share-rec-yes' -%}
        <button class="share-recommend-js load-product-presentation-form-js opening-modal-mobile-js" data-template="partials/product/product-presentation-forms.html" data-container=".recommend-product-js" data-url="{{ url }}" data-include="recommend-product">
            <svg><use href="css/img/fontawesome-icons.svg?v={{lqTS}}#thumbs-up-{{settings.iconStyle}}"></use></svg> {{ translations.RecommendProduct }}
        </button>
    {% endif -%}
</div>
`